var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _vm.orderNumber
      ? _c("div", [
          _vm._v("\n    Оплата заказа "),
          _c(
            "span",
            {
              staticClass: "link link_color_blue load-order-info",
              on: { click: _vm.showOrderPopup }
            },
            [_vm._v("№" + _vm._s(_vm.orderNumber))]
          )
        ])
      : !_vm.orderNumber && _vm.receipt
      ? _c("div", [
          _vm._v("\n    Оплата заказа №" + _vm._s(_vm.receipt) + "\n  ")
        ])
      : _vm._e(),
    _vm._v("\n\n  " + _vm._s(_vm.description) + "\n")
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }